<template>
  <v-container style="max-width:1200px" class="pt-0">
    <ASearchForm
      :modelName="'Station'"
      :create="hasEditPermission"
      :dropdownProps="[{type:'text',name: 'Name (contains)', payloadKey: 'name'},{model:'modules', name: 'Module', payloadKey: 'moduleId'}, {model:'workcenters', name: 'Work Center', payloadKey: 'workCenterId'}]"
      @change="search"
      @create="onCreate"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <ADataTable
      :headers="headers"
      :api="api"
      :sortBy="'listOrder'"
      :editAction="hasEditPermission"
      :deleteAction="hasEditPermission"
      :moveActions="hasEditPermission"
      @click:edit="onEdit"
      @click:delete="onDelete"
      @click:move="move"
      :hideTitleBar="true"
      :apiParams="apiParams"
      ref="table"
    ></ADataTable>
    <AFormDialog
      ref="formDialog"
      :fields="formMeta"
      :modelName="'Station'"
      :model="'stations'"      
      @modified="load"
    ></AFormDialog>
  </v-container>
</template>

<script>
import roleApi from "../api/role";
import snackbar from "../mixins/snackbar";
import ConfirmDialogMixin from "../mixins/ConfirmDialogMixin";
import PermissionsHelper from "../mixins/PermissionsHelper"
import ASearchForm from "../components/ASearchForm";
import ADataTable from "../components/ADataTable";
import AFormDialog from "../components/AFormDialog";
import crudFuncsMixin from "../mixins/CRUDFuncs";

export default {
  name: "Stations",
  mixins: [snackbar, ConfirmDialogMixin, crudFuncsMixin,PermissionsHelper],
  components: {
    ASearchForm,
    ADataTable,
    AFormDialog
  },
  data() {
    return {
      model: "stations",
      headers: [
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "List Order", value: "listOrder" },
        { text: "Work Center", value: "workCenterName" },
        { text: "Module", value: "moduleName" },
        { text: "Station Group", value: "stationGroupName" }
      ],
      apiParams: {},
      formMeta: [
        {
          type: "text",
          label: "Name*",
          queryParam: "name",
          rules: [
            v => (!!v && v.length >= 1) || "Should be atleast 1 characters"
          ],
          value: "",
          updatable: true
        },
        {
          type: "text",
          label: "Description",
          queryParam: "description",
          rules: [
            v => (!!v && v.length >= 1) || "Should be atleast 1 characters"
          ],
          value: "",
          updatable: true
        },
        {
          type: "dropdown",
          model: "workcenters",
          label: "Work Center*",
          queryParam: "workCenterId",
          rules: [v => v !== undefined || "This field is mandatory"],
          value: undefined,
          updatable: true
        },
        {
          type: "dropdown",
          model: "modules",
          label: "Module*",
          queryParam: "moduleId",
          rules: [v => v !== undefined || "This field is mandatory"],
          value: undefined,
          updatable: true
        },
        {
          type: "dropdown",
          model: "stationgroups",
          label: "Station Group",
          queryParam: "stationGroupId",
          // rules: [v => v !== undefined || "This field is mandatory"],
          value: undefined,
          nullable: true,
          updatable: true
        }
      ]
    };
  },
  methods: {
    search(payload) {
      this.apiParams = payload;
    }
  }
};
</script>

